import { SiteContext } from '@lib/site-context'
import { useContext, useEffect, useRef } from 'react'

const CookieDeclaration = () => {
  const { settings } = useContext(SiteContext)

  const legalContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!settings?.cookieBotId) {
      return
    }

    const script = document.createElement('script')
    script.id = 'CookieDeclaration'
    script.src = `https://consent.cookiebot.com/${settings.cookieBotId}/cd.js`
    script.type = 'text/javascript'
    script.async = true

    const legalContainerElement = legalContainerRef.current
    legalContainerElement?.appendChild(script)

    return () => {
      legalContainerElement?.removeChild(script)
    }
  }, [settings?.cookieBotId])

  return <div ref={legalContainerRef} />
}

export default CookieDeclaration
